import React from "react"
import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@material-ui/core"

import { enqueueSnackbar } from "notistack"
import { useTranslation } from "react-i18next"

import { ChatResponse } from "../api/chat-response"
import { useChatMutations } from "../hooks/use-chat-mutations"

type Props = {
  open: boolean
  chat: ChatResponse
  onClose: () => void
}

const DeleteChatDialog = ({ open, chat, onClose }: Props) => {
  const { t } = useTranslation("chat")
  const { t: common } = useTranslation("translation")
  const [loading, setLoading] = React.useState(false)

  const { deleteChat } = useChatMutations()

  const handleDelete = async () => {
    try {
      setLoading(true)

      await deleteChat(chat.id)

      enqueueSnackbar(t("deleteChatDialog.successMessage"), {
        variant: "success",
      })

      onClose()
    } finally {
      setLoading(false)
    }
  }

  return (
    <Dialog open={open} onClose={loading ? undefined : onClose} maxWidth="xs" fullWidth>
      <DialogTitle>{t("deleteChatDialog.title")}</DialogTitle>

      <DialogContent>
        <DialogContentText>{t("deleteChatDialog.text")}</DialogContentText>
      </DialogContent>

      <DialogActions>
        <Button disabled={loading} onClick={onClose}>
          {common("cancel")}
        </Button>

        <Button color="secondary" variant="contained" disabled={loading} onClick={handleDelete}>
          {loading ? <CircularProgress size={20} /> : common("deleteLabel")}
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default DeleteChatDialog
